import { ErrorDetailsModel } from "../../models/ErrorDetailsModel";

export const request = <T extends string>(type: T) => `${type}_REQUEST` as const;
export const success = <T extends string>(type: T) => `${type}_SUCCESS` as const;
export const failure = <T extends string>(type: T) => `${type}_FAILURE` as const;

export type Request<T extends string> = ReturnType<typeof request<T>>;
export type Success<T extends string> = ReturnType<typeof success<T>>;
export type Failure<T extends string> = ReturnType<typeof failure<T>>;

// fixes payload: unknown
type WithPayload<P> = P extends {} ? { payload: P } : {};

// 
//```ts
//AsyncAction<'TEST', { request: { q: string }, success: { answer: number }, failure: { data: string } } >
//```
// produces
// ```ts
//  { type: 'TEST_REQUEST', payload: { q: string } } 
//  | { type: 'TEST_SUCCESS', payload: { answer: number } } 
//  | { type: 'TEST_FAILURE', error?: ErrorDetailsModel; payload: { data: string } }
export type AsyncAction<
  TPrefix extends string,
  TPayloads extends { request?: any; success?: any; failure?: any } = {}
> =
  | ({ type: Request<TPrefix> } & WithPayload<TPayloads["request"]>)
  | ({ type: Success<TPrefix> } & WithPayload<TPayloads["success"]>)
  | ({ type: Failure<TPrefix> } & { error?: ErrorDetailsModel } & WithPayload<
        TPayloads["failure"]
      >);

export type Action<TPrefix extends string, TPayload = undefined> = {
  type: TPrefix;
} & WithPayload<TPayload>;
